// @ts-nocheck
import _ from 'lodash'
import ImgAsync from '../../../components/utils/ImgAsync.vue'
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex'

export default {
  components: {
    ImgAsync,
  },
  props: {
    mode: {
      type: String,
      default: 'LIGHT',
    },
  },
  data() {
    return {}
  },
  computed: {
    ...mapGetters({}),
    ...mapState('route', {}),
    ...mapState('globalTheme', {}),
  },
  methods: {
    ...mapActions({}),
    ...mapMutations({}),
    ...mapActions('globalTheme', {}),
  },
}
